<template>
  <CallPlanningLayout>
    <div class="hvh-flex space-between">
      <h4></h4>
      <div class="hvh-flex">
        <v-btn flat class="hvh-btn hvh-btn--secondary" @click="showColumns = true">
          <v-icon>mdi-format-columns</v-icon>
        </v-btn>
        <v-btn flat class="hvh-btn hvh-btn--secondary" :class="{ disabled: !columns }" @click="addUserEmail = ''">Add</v-btn>
      </div>
    </div>
    <DataTable :data="allUsers" :perPage="15" :isLoading="isLoadingUsers" noSearch>
      <template #head>
        <tr>
          <Th prop="email" sort>Email</Th>
          <Th prop="role" sort>Role</Th>
          <Th>Regions</Th>
          <Th>Territories</Th>
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td>
            <router-link :to="{ name: 'callPlanningAdminUser', params: { brandId, userId: item.id } }">{{ item.email }}</router-link>
          </td>
          <td>{{ item.role }}</td>
          <td>
            {{ item.regions.join(', ') || '-' }}
            <!-- <router-link :to="{ name: 'callPlanningManagerUser', params: { userId: item } }">{{ item }}</router-link> -->
          </td>
          <td>{{ item.territories.join(', ') || '-' }}</td>
        </tr>
      </template>
    </DataTable>

    <HvhModal title="Add User" :value="true" :isLoading="isLoadingUser" @input="addUserEmail = null" v-if="addUserEmail !== null">
      <v-text-field label="Email Address" v-model="addUserEmail" />
      <template v-slot:actions>
        <v-btn flat="flat" @click="addUserEmail = null">Cancel</v-btn>
        <v-btn flat="flat" @click="addUser">Add</v-btn>
      </template>
    </HvhModal>

    <CallPlanningChooseColumns v-model="columns" :brandId="brandId" :isLoading="isLoadingColumns" @input="saveColumns" @close="showColumns = false" v-if="showColumns" />

    <Loader v-if="isLoading" />
  </CallPlanningLayout>
</template>
<script>
import axios from '../../axios';
import CallPlanningLayout from '../../components/callPlanning/CallPlanningLayout.vue';
import Loader from '../../components/common/loader/Loader.vue';
import { errorDebug, hashCode, toFormData, tryParse, } from '../../libraries/common';
import DataTable from '../../components/common/dataTable/DataTable.vue';
import Th from '../../components/common/dataTable/Th.vue';
import HvhModal from '../../components/common/modal/HvhModal.vue';
import CallPlanningChooseColumns from '../../components/callPlanning/CallPlanningChooseColumns.vue';
export default {
  components: { Loader, CallPlanningLayout, DataTable, Th, HvhModal, CallPlanningChooseColumns, },
  data() {
    return {
      userEmail: null,
      user: null,
      managersTerritories: [],
      usersTerritories: [],
      isLoading: false,
      isLoadingUsers: false,
      isLoadingUser: false,
      isLoadingColumns: false,
      users: {},
      addUserEmail: null,
      columns: null,
      showColumns: false,
    }
  },
  computed: {
    brandId() {
      return this.$route.params.brandId;
    },
    allUsers() {
      var { users, managers } = this.users;
      return (managers || [])
        .map(f => ({ ...f, role: 'Manager' }))
        .concat((users || []).map(f => ({ ...f, role: 'User' })));
    },
  },
  methods: {
    calculateHash() {
      return hashCode({
        managersTerritories: this.managersTerritories,
        usersTerritories: this.usersTerritories,
      });
    },
    addUser() {
      this.isLoadingUser = true;
      return axios.get(`/api/CallPlanning/${this.brandId}/Admin/Users/FindByEmail/${this.addUserEmail}`)
        .then(({ data }) => this.$router.push({ name: 'callPlanningAdminUser', params: { brandId: this.brandId, userId: data } }))
        .catch(errorDebug)
        .then(() => this.isLoadingUser = false);
    },
    getUsers() {
      this.isLoadingUsers = true;
      axios.get(`/api/CallPlanning/${this.brandId}/Admin/GetUsers`)
        .then(({ data }) => this.users = data)
        .catch(errorDebug)
        .then(() => this.isLoadingUsers = false);
    },
    saveColumns() {
      this.isLoadingColumns = true;
      axios.post(`/api/CallPlanning/Brands/${this.brandId}/Columns`, toFormData({ columns: JSON.stringify(this.columns) }))
        .then(() => this.showColumns = false)
        .catch(errorDebug)
        .then(() => this.isLoadingColumns = false);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCallPlanningAdmin'] = this;

    this.getUsers();

    axios.get(`/api/CallPlanning/Brands/${this.brandId}/Columns`)
      .then(({ data }) => this.columns = tryParse(data));
  },
}
</script>
